"use client";

import { ChevronDown, SlidersHorizontal } from "@/components/icons";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useHeroMapContext } from "@/components/home/context/hero-map-context";
import { useListingBrowseContext } from "../context/listing-browse-context";
import { SegmentedControl } from "@/components/ui/segmented-control";
import { ActiveCountBadge, SET_CHIP_CLASS } from "./filter-chip";
import { QuantityFields } from "./primary-filters";
import { LISTED_AFTER_OPTIONS } from "./secondary-filters";

const ANY_TIME = "any";

function ListedWithinOptions() {
  const { listedAfterDays, setListedAfterDays } = useListingBrowseContext();
  return (
    <div>
      <div className="text-xs font-medium text-muted-foreground px-2 py-1 mb-1">Listed within</div>
      <SegmentedControl
        size="compact"
        aria-label="Listed within"
        value={listedAfterDays === null ? ANY_TIME : String(listedAfterDays)}
        onValueChange={(next) => setListedAfterDays(next === ANY_TIME ? null : Number(next))}
        options={[
          { value: ANY_TIME, label: "Any" },
          ...LISTED_AFTER_OPTIONS.map((option) => ({ value: option.value, label: option.shortLabel })),
        ]}
      />
    </div>
  );
}

export function MoreFiltersChip() {
  const { listedAfterDays } = useListingBrowseContext();
  const heroMap = useHeroMapContext();
  const activeCount =
    (listedAfterDays !== null ? 1 : 0) + ((heroMap.quantity ?? 1) !== 1 ? 1 : 0);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="compact"
          className={cn("rounded-sm", activeCount > 0 ? SET_CHIP_CLASS : "text-muted-foreground")}
        >
          <SlidersHorizontal className="w-3.5 h-3.5" />
          More filters
          <ActiveCountBadge activeCount={activeCount} />
          <ChevronDown className="w-3.5 h-3.5" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[280px] space-y-3 rounded-sm border-border p-2">
        <ListedWithinOptions />
        <QuantityFields />
      </PopoverContent>
    </Popover>
  );
}
